(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("FEGOBridge"), require("FEGOVue"), require("FEGORender"));
	else if(typeof define === 'function' && define.amd)
		define(["FEGOBridge", "FEGOVue", "FEGORender"], factory);
	else if(typeof exports === 'object')
		exports["/fego/component/flow-scroll-quotes/render"] = factory(require("FEGOBridge"), require("FEGOVue"), require("FEGORender"));
	else
		root["/fego/component/flow-scroll-quotes/render"] = factory(root["FEGOBridge"], root["FEGOVue"], root["FEGORender"]);
})(self, function(__WEBPACK_EXTERNAL_MODULE__7145__, __WEBPACK_EXTERNAL_MODULE__9666__, __WEBPACK_EXTERNAL_MODULE__5322__) {
return 